import { render, staticRenderFns } from "./DigitalMailbox.vue?vue&type=template&id=74232c1e&"
import script from "./DigitalMailbox.vue?vue&type=script&lang=js&"
export * from "./DigitalMailbox.vue?vue&type=script&lang=js&"
import style0 from "./DigitalMailbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports